import React, { useCallback, useState } from 'react';
import { Collapse } from '@mui/material';
import { TimeSignalAttribute } from 'graphql/types';
import { NoteMore, NoteAttributes } from '../NoteBody';

type AttributesContentProps = {
  attributes?: TimeSignalAttribute[];
  moreClassName?: string;
};
export const AttributesContent: React.FC<AttributesContentProps> = ({
  attributes,
  moreClassName
}: AttributesContentProps) => {
  const [expanded, setExpanded] = useState(false);
  const handleNoteAttribute = useCallback(() => {
    setExpanded((exp) => !exp);
  }, [setExpanded]);
  if (!attributes?.length) {
    return <></>;
  }

  return (
    <>
      <NoteMore onClick={handleNoteAttribute} className={moreClassName} />
      <Collapse in={expanded}>
        <NoteAttributes attributes={attributes} />
      </Collapse>
    </>
  );
};
